<template>
  <v-card>
    <v-card-title class="mb-3">
      {{ labels.pulse }}
    </v-card-title>
    <v-card-text>
      <div class="definition-card-container">
        <p>
          {{ labels.pulse }} continuously identifies micro-changes in stability
          and looks for anomalies to alert users to actions that may pose a risk
          or present an opportunity to their operation.
          {{ labels.pulse }} triggered alerts notify analysts of important
          developments, speed the process of finding and accessing
          mission-relevant data, and enable analysts to maintain situational
          awareness.
        </p>
        <p>
          {{ labels.pulse }} employs a revolutionary algorithm that analyzes
          both long-term and breaking information to develop living stability
          assessments worldwide.
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { LABELS } from "@/common/constants/labels";

export default {
  name: "StabilityDescription",
  components: {},
  data() {
    return {
      labels: LABELS,
    };
  },
};
</script>
